export enum MailLabelStateEnum {
  PENDING = "PENDING",
  FAILED = "FAILED",
  RETRYING = "RETRYING",
  ERROR = "ERROR",
  CREATED = "CREATED",
}
